import React, { useEffect, useState, useContext } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom';
import { toast } from "react-toastify";

import { invalidateStoryboardList } from 'actions/storyboardList';
import { deleteAssetMappings, invalidateDuplicateAssets, updateAssetMappings, invalidateFilterSortInContentManager, invalidateAssetMappings } from 'actions/content';

import _ from 'lodash';
import cx from 'classnames';
import { EditorContext } from 'components/Editor/index';
import { DuplicateAssetToast } from 'components/Toast';

import {
  Modal,
  Button,
  TabContainer,
  Tab,
  Nav
} from 'react-bootstrap'

import StoryboardView from './Storyboard'
import ContentView from "./allContents";
import AssetUploader from "./assetUploader";
import StoryboardContext from "components/Storyboard/context";
import { deleteAssetGating } from 'actions/gatingConfigurations';

import { FOLDER_LIST } from 'constants/assetManagerLists'
import styles from './assetManager.module.scss';
import { getPageViewedEventPayload } from 'services/mixpanelUtil';
import { MIXPANEL_PAGE_VIEWED, MIXPANEL_PAGE_VIEWED_CONTENT_MANAGER } from 'constants/mixpanelEvents';
import { createMixpanelEvent } from 'actions/mixpanel';


const AssetManagerModal = ({ editorSession, show, multiple=true, edit, onFinish, onClose, onDelete, disableCleverstory, inline, allowType}) => {
  return (
    <Modal show={show} className={styles.assetManagerContainer} backdropClassName={styles.backdrop} centered>
      <AssetManager
        editorSession={editorSession}
        multiple={multiple}
        edit={edit}
        onFinish={onFinish}
        onClose={onClose}
        onDelete={onDelete}
        disableCleverstory={disableCleverstory} 
        inline={inline}
        allowType={allowType}
      />
    </Modal>
  )
}

const AssetManager = ({ editorSession, onFinish, multiple=true, onClose, edit, selected, onDelete, disableCleverstory, inline, allowType}) => {
  
  const dispatch = useDispatch();

  const [uploadingAsset, setUploadingAsset] = useState(false);
  const storyboard = useSelector((state) => _.get(state, `storyboards.storyboard.item`, {}));
  let duplicates = useSelector(state => _.get(state, `content.duplicates`, []));

  useEffect(() => {
    if(duplicates && _.size(duplicates) > 0){

      duplicates.map( (duplicate) => {
        if(duplicate && duplicate.processed && duplicate.similarAsset){
          toast(
            <DuplicateAssetToast duplicate={duplicate} storyboard={storyboard} closeToast={()=>toast.dismiss(duplicate.id)} />,
            {
              toastId: duplicate.id,
              type: toast.TYPE.DEFAULT,
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: false,
              closeOnClick: false,
              closeButton: false,
              draggable: false
            }
          )

          let isAllProcessed = duplicates.every(duplicate => duplicate.processed == true);
          if(isAllProcessed){
            dispatch(invalidateDuplicateAssets());
          }
        }
      })
    }
  }, [duplicates]);

  const closeModal = () => {
    dispatch(invalidateFilterSortInContentManager());
    dispatch(invalidateAssetMappings());
    onClose();
  }

  return (
    <div className={styles.assetManager}>
      <div className={styles.header}>
        <h1 className={styles.title}>Content Manager</h1>

        <div className={styles.actionContainer}>
          <AssetUploader className={styles.uploadButton} storyboard={storyboard} handleViewChange={(value) => { setUploadingAsset(value) }} inline={inline} />
          <Button variant='info' onClick={()=>closeModal()} className={styles.closeButton}>
            <i className={cx('cleverstory-close', styles.closeButtonIcon)} />
          </Button>
        </div>
      </div>
      <div className={styles.body}>
        <ContentsRenderSection 
          editorSession={editorSession}
          edit={edit}
          onFinish={onFinish}
          multiple={multiple}
          selected={selected}
          storyboard={storyboard}
          uploadingAsset={uploadingAsset}
          onDelete={onDelete}
          disableCleverstory={disableCleverstory}
          inline={inline}
          allowType={allowType}
        />
      </div>
    </div>
  )
}

const ContentsRenderSection = ({ editorSession, edit, onFinish, storyboard, uploadingAsset, multiple, selected, onDelete, disableCleverstory, inline, allowType}) => {
  const dispatch = useDispatch();

  const contents = useSelector(state => _.get(state, 'content.assets')) || [];
  let totalContents = useSelector(state => _.get(state, 'content.pagination.totalRecordsCount')) || 0;
  const contentSize = !_.isEmpty(contents) ? _.size(contents) : totalContents;

  
  const updating = useSelector(state => _.get(state, 'content.updating', false));
  const checkAssetUpdate = contents.some(obj => obj.changes === true);
  const gatingConfigurations = useSelector((state) => _.get(state, `gatingConfigurations`, {}) || {});
  const deletedGatingsId = useSelector((state) => _.get(state, `gatingConfigurations.deletedGating`, {}) || {});
  const storyboardId =  _.get(storyboard, 'id')
  const storyboardName =  _.get(storyboard, 'name')
  const storyboardType =  _.get(storyboard, 'type')

  const [state, setState] = useState({
    view: '',
    selection: []
  })
  const [expand, setExpand] = useState(true);

  const handleViewChange = (view) => {
    if (!view) {
      return;
    }

    setState((state) => {
      return {
        ...state,
        view: view
      }
    })
  }

  useEffect(() => {
    handleViewChange('allContent');

    var mixPanelPayload = getPageViewedEventPayload(MIXPANEL_PAGE_VIEWED_CONTENT_MANAGER, storyboardId, storyboardName, storyboardType)
    dispatch(createMixpanelEvent(MIXPANEL_PAGE_VIEWED, mixPanelPayload))
    
    return () => {
      dispatch(invalidateFilterSortInContentManager());
      dispatch(invalidateAssetMappings())
    }
  }, [])

  const handleSave = () => {
    onFinish(state.selection);
  }

  const handleSelectionChange = (value) => {
    setState((state) => {
      return {
        ...state,
        selection: value
      }
    });
  }

  useEffect(() => {
    if (uploadingAsset) {
      handleViewChange('allContent')
    }
  }, [uploadingAsset])

  const handleDeleteAssets = () => {
    if (state.view !== 'allContent') {
      return;
    }

    var assetIds = (state.selection).map(item => item.asset.id);

    var request = {
      mappings: assetIds,
      storyboard: _.get(storyboard, 'id')
    }

    dispatch(deleteAssetMappings(request));

    setState((state) => {
      return {
        ...state,
        selection: []
      }
    });

    if (onDelete) {
      onDelete(assetIds);
    }
  }

  const handleAssetUpdate = () => {
    const updatedContents = _.filter(contents, (data) => { return data.changes === true });

    var assetMappings = _.map(updatedContents, (item) => {
      const assetData = _.get(item, 'asset');
      return {
        id: item.id,
        asset: {
          id: _.get(assetData, 'id', ""),
          name: _.get(assetData, 'name', ""),
          icon: _.get(assetData, 'icon'),
          summary: _.get(assetData, 'summary', ""),
          tags: _.get(item, 'tags') || [],
          viewerMode: _.get(assetData, 'viewerMode')
        },
        source: item.source || 'CLEVERSTORY',
        customFields: item.customFields || [],
        disableDownload: item.disableDownload,
        excludeFromSearch: item.excludeFromSearch,
        contentType: _.get(assetData, 'metadata.content_type', ""),
      }
    })

    var updatedGatingConfigurations = updatedContents.reduce((newList, current) => {
      let gatingConfigs = _.get(gatingConfigurations, `${current.id}.items`, []) || [];
      gatingConfigs = _.filter(gatingConfigs, obj => _.has(obj, 'updated') && _.has(obj, 'gating'))
      if (_.size(gatingConfigs) < 1) {
        return [];
      }

      gatingConfigs = _.map(gatingConfigs, (gate) => {
        return {
          id: _.get(gate, 'id') ? _.get(gate, 'id') : null,
          name: _.get(gate, 'name'),
          enabled: _.get(gate, 'enabled'),
          optional: _.get(gate, 'optional'),
          target: {
            id: _.get(current, 'id'),
            type: 'asset'
          },
          trigger: _.get(gate, 'trigger'),
          gating: _.get(gate, 'gating.id'),
        }
      })
      return newList.concat(gatingConfigs);
    }, [])

    var request = {
      assetMappings: assetMappings,
      gatingConfigurations: updatedGatingConfigurations
    }

    dispatch(updateAssetMappings(storyboard.id, request));
    if (_.size(deletedGatingsId) > 0) {
      dispatch(deleteAssetGating(storyboard.id, deletedGatingsId))
    }
  }

  useEffect(() => {
    const updatedSelection = state.selection.filter(selectedItem =>
      contents.some(contentItem => contentItem.asset.id === selectedItem.asset.id)
    );

    if (updatedSelection.length !== state.selection.length) {
      setState(state => ({
        ...state,
        selection: updatedSelection
      }));
    }

    if (selected) {
      setState(state => ({
        ...state,
        selection: [selected]
      }));
    }
  }, [contents]);

  return (
    <div className={styles.tabSection}>
      <TabContainer defaultActiveKey={'allContent'} activeKey={state.view} onSelect={handleViewChange}>
        <section className={cx(styles.sideMenu, { [styles.expandMenu]: !expand })}>
          <Button variant='info' className={cx(styles.expandButton, { [styles.collapsedButton]: !expand })} onClick={() => setExpand(!expand)}>
            <div className={cx(styles.iconWrapper, { [styles.rotateIcon]: !expand })}>
              <i className={cx(`cleverstory-drop-down`, styles.icon)} />
            </div>
            <span className={cx(styles.text, { [styles.fadeOut]: !expand })}>Collapse</span>
          </Button>

          <Nav className={styles.sources}>
            {expand && <h5>LOCAL</h5>}
            {FOLDER_LIST.map((list) => {
              return (
                <Nav.Item className={cx(styles.source)} key={list.type}>
                  <Nav.Link eventKey={list.type} className={cx(styles.navButton, { [styles.smallButton]: !expand })}>
                    <i className={cx(`cleverstory-${list.icon}`, styles.icon)} />
                    <span className={cx(styles.label, { [styles.fadeOut]: !expand })}>{list.label}</span>
                  </Nav.Link>
                </Nav.Item>
              )
            })}
          </Nav>
        </section>
        <section className={styles.content}>
          <section className={cx(styles.wrapper)}>
            <Tab.Content className={styles.tabContainer}>
              <Tab.Pane className={styles.tabPanes} eventKey="allContent">
                <ContentView
                  editorSession={editorSession}
                  selection={state.selection}
                  multiple={multiple}
                  storyboard={storyboard}
                  onSelectionChange={handleSelectionChange}
                  onDelete={handleDeleteAssets}
                  inline={inline}
                  allowType={allowType}
                />
              </Tab.Pane>
            </Tab.Content>
          </section>
          <div className={styles.footer}>
            <span className={styles.selection}>Selected Content : {`${state.selection.length}`}/{`${contentSize}`}</span>
            <div className={styles.actionContainer}>
              <Button
                size="sm"
                variant="primary"
                onClick={handleAssetUpdate}
                disabled={(!checkAssetUpdate) || updating}
                className={styles.saveButton}
              >
                {updating ? 'Saving...' : 'Save Changes'}
              </Button>

              {!edit &&
                <Button className={styles.addAssetButton}
                  onClick={handleSave}
                  size="sm"
                  variant="primary"
                  disabled={_.size(state.selection) == 0 || updating}
                >
                  Add to Layout
                </Button>
              }
            </div>
          </div>
        </section>
      </TabContainer>
    </div>
  )
}

export { AssetManagerModal, AssetManager, ContentsRenderSection };